import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'selected',
    path: 'location_ids',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(value.location_ids)
  }
}
